module.exports = __webpack_public_path__ + "static/media/asmat_hope.596263ff.jpg";